import { ReactNode } from 'react';
import {
  Dialog,
  DialogDescription,
  DialogTitle,
  AppDialogContent,
  AppDialogHeader,
  AppDialogBody,
  AppDialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

interface ConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: ReactNode;
  description?: ReactNode;
  confirmText?: string;
  cancelText?: string;
  isPending?: boolean;
  disabled?: boolean;
  variant?: 'default' | 'destructive';
  onConfirm: () => void;
  summary?: ReactNode;
}

export const ConfirmDialog = ({
  open,
  onOpenChange,
  title,
  description,
  confirmText = 'Xác nhận',
  cancelText = 'Hủy',
  isPending = false,
  disabled = false,
  variant = 'default',
  onConfirm,
  summary,
}: ConfirmDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <AppDialogContent
        className="max-w-md"
        onKeyDown={(event) => {
          if (event.key === 'Enter' && !isPending && !disabled) {
            event.preventDefault();
            onConfirm();
          }
        }}
      >
        <AppDialogHeader>
          <DialogTitle>{title}</DialogTitle>
          {description ? <DialogDescription>{description}</DialogDescription> : null}
        </AppDialogHeader>

        {summary ? <AppDialogBody>{summary}</AppDialogBody> : null}

        <AppDialogFooter>
          <Button
            type="button"
            variant={variant === 'destructive' ? 'destructive' : 'default'}
            onClick={onConfirm}
            disabled={isPending || disabled}
          >
            {isPending ? 'Đang xử lý...' : confirmText}
          </Button>
          <Button type="button" variant="outline" onClick={() => onOpenChange(false)} disabled={isPending}>
            {cancelText}
          </Button>
        </AppDialogFooter>
      </AppDialogContent>
    </Dialog>
  );
};
